const AnimatedToggle = (
  <div className="navbar-toggle">
    <span className="sr-only">Toggle navigation</span>
    <span className="icon-bar top-bar"></span>
    <span className="icon-bar middle-bar"></span>
    <span className="icon-bar bottom-bar"></span>
  </div>
);

export default AnimatedToggle;
